export default __webpack_public_path__ + "static/media/time.400afd5a.svg";